/* eslint-disable ember/classic-decorator-hooks */
import EmberObject from '@ember/object';
import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';

export default class SallenKeyLowPassIdealOpAmp extends EmberObject {
  // Inputs
  r1 = null;
  r3 = null;
  r4 = null;
  c2 = null;
  optimization = null;
  stageFp = null;
  gain = null;
  stageQ = null;
  algorithm = null;

  // Outputs
  iBias = null;
  gbw = null;
  rOut = null;
  rOutOverGBW = null;
  specialGain = null;
  name = 'ideal';
  slewRate = 0;

  init() {
    super.init();

    if (
      CommonUtils.isNullOrUndefined(this.r1) ||
      CommonUtils.isNullOrUndefined(this.r3) ||
      CommonUtils.isNullOrUndefined(this.r4) ||
      CommonUtils.isNullOrUndefined(this.c2) ||
      CommonUtils.isNullOrUndefined(this.stageFp) ||
      CommonUtils.isNullOrUndefined(this.stageQ) ||
      CommonUtils.isNullOrUndefined(this.gain) ||
      CommonUtils.isNullOrUndefined(this.optimization) ||
      CommonUtils.isNullOrUndefined(this.algorithm)
    ) {
      throw 'Required values are incomplete. Please provide r1, r3, r4, c2, stageQ, stageFp, gain, optimization, and algorithm';
    }

    this.iBias = this.computeIBias();
    this.specialGain = this.computeSpecialGain();
    this.gbw = this.computeGbw();
    this.rOutOverGBW = this.computeROutOverGBW();
    this.rOut = this.computeROut(this.gbw, this.rOutOverGBW);
  }

  computeSpecialGain() {
    var result = 1 + this.r4 / this.r3;
    return result;
  }

  computeIBias() {
    var dcOutputVoltageFromIBias = this.optimization.opAmpRequirementSpecValues.dcOutputVoltageFromIBias;
    var iBiasResistance = this.r1 + this.r2;
    var result = dcOutputVoltageFromIBias / iBiasResistance / this.gain;
    return result;
  }

  computeGbw() {
    var allowedError = this.optimization.opAmpRequirementSpecValues.allowedError;
    var gain = this.gain;
    var epsilon = (allowedError + 1) * (allowedError + 1) - 1;
    var numerator = gain * gain;
    var denominator = this.c2 * this.r2 * 2 * Math.PI * epsilon;
    var result = numerator / denominator;
    return result;
  }

  computeROutOverGBW() {
    var stopbandFrequency = this.optimization.opAmpRequirementSpecValues.stopbandFrequency;
    var rOutFreqMultiplier = this.optimization.opAmpRequirementSpecValues.rOutFreqMultiplier;
    var attenuation = (stopbandFrequency / this.stageFp) * (stopbandFrequency / this.stageFp);
    var f = stopbandFrequency * rOutFreqMultiplier;
    var result = ((1 / f) * this.r1) / (attenuation - this.r1 / this.r2 - 1);

    if (result < 0) {
      result = FilterConstants.Limits.INFINITY;
    }

    return result;
  }

  computeROut(gbw, rOutOverGbw) {
    var result = rOutOverGbw * gbw;
    return result;
  }
}
